import { useState, useEffect } from 'react';

interface FloatingButtonsProps {
  onAgendar: () => void;
}

const Tooltip = ({
  label,
  side,
}: {
  label: string;
  side: 'left' | 'right';
}) => (
  <span
    className={`
      pointer-events-none absolute top-1/2 -translate-y-1/2
      bg-gray-900/90 text-white text-xs font-medium px-2.5 py-1.5 rounded-lg
      whitespace-nowrap opacity-0 group-hover:opacity-100
      transition-all duration-200 hidden sm:block
      ${side === 'right' ? 'left-14' : 'right-14'}
    `}
  >
    {label}
    {/* arrow */}
    <span
      className={`
        absolute top-1/2 -translate-y-1/2 border-4 border-transparent
        ${side === 'right'
          ? '-left-1.5 border-r-gray-900/90'
          : '-right-1.5 border-l-gray-900/90'}
      `}
    />
  </span>
);

export default function FloatingButtons({ onAgendar }: FloatingButtonsProps) {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShowTop(window.scrollY > 400);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const btnCircle =
    'w-12 h-12 flex items-center justify-center rounded-full shadow-lg transition-all duration-300 cursor-pointer';

  return (
    <>
      {/* WhatsApp */}
      <div className="fixed bottom-6 left-4 sm:left-6 z-50 group">
        <a
          href="https://wa.me/5548991002443"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Falar pelo WhatsApp"
          className={`${btnCircle} bg-[#25D366] text-white hover:bg-[#1ebe5d] hover:scale-110`}
        >
          <i className="ri-whatsapp-line text-xl" />
        </a>
        <Tooltip label="Falar pelo WhatsApp" side="right" />
      </div>

      {/* Agendar */}
      <div className="fixed bottom-6 right-4 sm:right-6 z-50 group">
        <button
          onClick={onAgendar}
          aria-label="Agendar Consulta"
          className={`${btnCircle} bg-[#C4A57B] text-white hover:bg-[#B39568] hover:scale-110`}
        >
          <i className="ri-calendar-check-line text-xl" />
        </button>
        <Tooltip label="Agendar Consulta" side="left" />
      </div>

      {/* Voltar ao topo */}
      <div
        className={`fixed right-4 sm:right-6 z-50 group transition-all duration-300
          ${showTop ? 'bottom-24 opacity-100 pointer-events-auto' : 'bottom-20 opacity-0 pointer-events-none'}`}
      >
        <button
          onClick={scrollToTop}
          aria-label="Voltar ao topo"
          className={`${btnCircle} bg-white border border-[#C4A57B] text-[#C4A57B] hover:bg-[#C4A57B] hover:text-white hover:scale-110`}
        >
          <i className="ri-arrow-up-line text-xl" />
        </button>
        <Tooltip label="Voltar ao topo" side="left" />
      </div>
    </>
  );
}
